import React, { useState } from 'react';
import './SubscribeBlock.css';

const SubscribeBlock = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('pending');

    try {
      const response = await fetch('/api/subscriptions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ client_email: email }),
      });

      if (!response.ok) throw new Error('Failed');

      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus(null), 5000);
    } catch (error) {
      setStatus('error');
      console.error('Subscription error:', error);
    }
  };

  return (
    <section className={`subscribe-section page-section ${className}`.trim()}>
      <div className="page-container">
        <div className="subscribe-block">
          <h2>Подпишитесь на рассылку</h2>
          <p>Еженедельные идеи для путешествий и спецпредложения на вашу почту.</p>
          <form className="subscribe-form" onSubmit={handleSubmit}>
            <input
              type="email"
              name="client_email"
              placeholder="Введите ваш email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="btn-primary" disabled={status === 'pending'}>
              {status === 'pending' ? 'Отправка...' : 'Подписаться'}
            </button>
          </form>
          {status === 'success' && <p className="form-status success">Подписка оформлена!</p>}
          {status === 'error' && <p className="form-status error">Ошибка. Попробуйте снова.</p>}
        </div>
      </div>
    </section>
  );
};

export default SubscribeBlock;
